import { useState, useMemo } from "react";
import { useMutation } from "@stadium/services/react-query";

import { getProductOptionValueId } from "@helpers/product-details";

import { getVariantsQuantity, getProductExternalIds } from "@helpers/products/tile";

import { fetchProductQuantityDetails } from "apis/product";

import { WAREHOUSE_PRODUCT, OPTIONTYPE_COLOR_KEY } from "@constants/products/detail";

const DEFAULT_OBJ = {};

export const useFetchInventoryDetails = ({ type = WAREHOUSE_PRODUCT, filterCallback } = {}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [variantData, setVariantData] = useState(DEFAULT_OBJ);

  const {
    data,
    isLoading: isFetchApiCallLoading,
    mutateAsync,
  } = useMutation({
    mutationFn: async (products) => {
      if (!products?.length) {
        return;
      }
      let filteredProducts;
      if (filterCallback) {
        filteredProducts = products.filter(filterCallback);
      } else if (type) {
        filteredProducts = products.filter(({ type }) => type === WAREHOUSE_PRODUCT);
      } else {
        filteredProducts = products;
      }

      const externalProductIds = getProductExternalIds(filteredProducts);

      if (!externalProductIds.length) {
        return {};
      }

      setIsFetching(true);

      const inventoryData = await fetchProductQuantityDetails({
        product_ids: `[${externalProductIds}]`,
      });

      setIsFetching(false);

      const defaultSizeId = getProductOptionValueId(products[0])?.id;
      const defaultColorId = getProductOptionValueId(products[0], OPTIONTYPE_COLOR_KEY)?.id;
      const formattedInventoryData = getVariantsQuantity({
        inventoryData,
        products,
        defaultSizeId,
        defaultColorId,
      });
      setVariantData(formattedInventoryData);

      return inventoryData;
    },
  });

  const value = useMemo(
    () => ({
      fetchInventoryDetails: mutateAsync,
      isInventoryFetching: isFetching || isFetchApiCallLoading,
      variantData,
      rawResponse: data,
    }),
    [data, isFetching, variantData, isFetchApiCallLoading, mutateAsync],
  );

  return value;
};
